import { render } from "./Home.vue?vue&type=template&id=bb7cba14&scoped=true&bindings={}"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=bb7cba14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bb7cba14"

export default script